export const FLEX_BASIS = {
	'1/2' : 'basis-1/2',
	'full': 'basis-full',
} as const;
export type FlexBasis = keyof typeof FLEX_BASIS;


export const FLEX_DIRECTION = {
	row: 'flex-row',
	rowReverse: 'flex-row-reverse',
	col: 'flex-col',
	colReverse: 'flex-col-reverse',
} as const;
export type FlexDirection = keyof typeof FLEX_DIRECTION;


export const FLEX_DIRECTION_TABLET = {
	row: 'tablet:flex-row',
	rowReverse: 'tablet:flex-row-reverse',
	col: 'tablet:flex-col',
	colReverse: 'tablet:flex-col-reverse',
} as const;
export type FlexDirectionTablet = keyof typeof FLEX_DIRECTION_TABLET;


export const FLEX_GROW = {
	0: 'grow-0',
	1: 'grow',
	2: 'grow-2',
} as const;
export type FlexGrow = keyof typeof FLEX_GROW;


export const FLEX_SHRINK = {
	0: 'shrink-0',
	1: 'shrink',
} as const;
export type FlexShrink = keyof typeof FLEX_SHRINK;


export const FLEX_WRAP = {
	nowrap: 'flex-nowrap',
	wrap: 'flex-wrap',
	wrapReverse: 'flex-wrap-reverse',
} as const;
export type FlexWrap = keyof typeof FLEX_WRAP;
